export default __webpack_public_path__ + "static/media/ftek.9f2dbc7b.svg";